module.exports = __webpack_public_path__ + "src/images/measurements/bicepCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/bicepCircumference.jpg
// module id = 1141
// module chunks = 0